import { WebPlugin } from '@capacitor/core';
export class SmsReaderWeb extends WebPlugin {
    constructor() {
        super({
            name: 'SmsReader',
            platforms: ['web'],
        });
        this.mockedItems = [];
    }
    read(_) {
        return Promise.resolve({
            items: [...this.mockedItems],
        });
    }
    mockSmsList(items) {
        this.mockedItems = items;
        return Promise.resolve();
    }
}
const SmsReader = new SmsReaderWeb();
export { SmsReader };
import { registerWebPlugin } from '@capacitor/core';
registerWebPlugin(SmsReader);
//# sourceMappingURL=web.js.map